import React from 'react'
import { FieldProps } from 'formik'
import { FormControlLabel, Checkbox } from '@material-ui/core'
import { CheckBoxOutlined } from '@material-ui/icons'
import styled from 'styled-components'

interface ICustomCheckboxField {
  label: string
  placeholder?: string
  value?: boolean
}

const StyledFormControlLabel = styled(FormControlLabel)`
  padding-left: 16px;
  font-size: 16px;

  h2 {
    word-break: break-all;
  }
` as any

export const CustomCheckboxField = ({
  field,
  form,
  ...props
}: FieldProps<any> & ICustomCheckboxField) => (
  <StyledFormControlLabel
    control={
      <Checkbox
        color="primary"
        {...field}
        {...props}
        checked={props.value || field.value}
        value={props.value === true ? 'checked' : undefined}
        checkedIcon={<CheckBoxOutlined />}
      />
    }
    label={props.label}
  />
)
